import Constants from '@app/constants';

/**
 * Reads the Okta access token from local storage. Returns null rather than
 * throwing so a missing or malformed entry degrades to an unauthenticated
 * request instead of breaking the caller.
 */
const getAccessToken = (): string | null => {
  try {
    const item = localStorage.getItem(Constants.tokenKey);
    return item ? JSON.parse(item)?.accessToken?.accessToken ?? null : null;
  } catch {
    return null;
  }
};

export default getAccessToken;
